import React, { useState } from "react";
import PropTypes from "prop-types";
import { withFormik } from "formik";
import { useTranslation } from "react-i18next";
import moment from "moment";
import DatePicker from "../../../components/DatePicker/DatePickerInput";
import { getPaymentTypeOptions } from "../utils/payment-history.helpers";
import {
  FiltersContainer,
  FilterFormRow,
  FilterInputContainer,
  FilterDatePickerWrapper,
  LinkText,
  ButtonsContainer,
  FilterButton,
  FilterIcon,
  FilterSelect,
  FieldsContainer
} from "../styles";

const spyGlass = "/assets/images/spy-glass.png";

const Filters = ({
  values,
  setFieldValue,
  onFilter,
  campaigns,
  cleanFilters
}) => {
  const { t } = useTranslation();
  const [touchedIcon, setTouchedIcon] = useState(false);
  const paymentTypeOptions = getPaymentTypeOptions(t);

  return (
    <FiltersContainer>
      <FieldsContainer>
        <FilterFormRow background={true}>
          <FilterInputContainer widthSmartphone="100">
            <FilterSelect
              label={t("paymentsHistory.byCampaign")}
              name="campaignId"
              id="campaign-id"
              placeholder={t("paymentsHistory.byCampaign")}
              options={campaigns}
              onChange={(event) => {
                setFieldValue("campaignId", event.target.value);
              }}
              value={values.campaignId}
            />
          </FilterInputContainer>
        </FilterFormRow>
        <FilterFormRow background={true}>
          <FilterInputContainer widthSmartphone="100">
            <FilterDatePickerWrapper>
              <DatePicker
                data-testid="from_date"
                id="payments-date-picker-from"
                value={values.yearMonth}
                onChange={(dateSelected) => {
                  const yearMonth = `${moment(dateSelected).format(
                    "YYYY"
                  )}-${moment(dateSelected).format("M")}`;
                  setFieldValue("yearMonth", yearMonth);
                }}
                placeholder={t("paymentsHistory.byMonth")}
                withPortal={true}
                dateFormat="yyyy-MM"
                showMonthYearPicker={true}
                setTouchedIcon={setTouchedIcon}
                errorMessage={t(
                  "paymentsHistory.validations.date_by_month.required"
                )}
              />
            </FilterDatePickerWrapper>
          </FilterInputContainer>
        </FilterFormRow>
        <FilterFormRow background={true}>
          <FilterInputContainer background={true} widthSmartphone="100">
            <FilterSelect
              label={t("paymentsHistory.byPaymentType")}
              name="paymentType"
              id="payment-type"
              placeholder={t("paymentsHistory.byPaymentType")}
              options={paymentTypeOptions}
              onChange={(event) => {
                setFieldValue("paymentType", event.target.value);
              }}
              value={values.paymentType}
            />
          </FilterInputContainer>
        </FilterFormRow>
      </FieldsContainer>
      <ButtonsContainer>
        <FilterButton id="filter-button" onClick={() => onFilter(values)}>
          {t("paymentsHistory.searchButton")}
          <FilterIcon src={spyGlass} />
        </FilterButton>
        <LinkText
          id="clean-filters"
          onClick={() => {
            setFieldValue("campaignId", "");
            setFieldValue("yearMonth", "");
            setFieldValue("paymentType", "");
            cleanFilters();
          }}
        >
          {t("paymentsHistory.cleanFilters")}
        </LinkText>
      </ButtonsContainer>
    </FiltersContainer>
  );
};

Filters.propTypes = {
  values: PropTypes.shape({
    campaignId: PropTypes.string,
    yearMonth: PropTypes.string,
    paymentType: PropTypes.string
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  onFilter: PropTypes.func.isRequired,
  cleanFilters: PropTypes.func.isRequired,
  campaigns: PropTypes.array.isRequired
};

export default withFormik({
  mapPropsToValues: () => ({
    campaignId: "",
    yearMonth: "",
    paymentType: ""
  })
})(Filters);
